import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { scaleRotate as Menu } from 'react-burger-menu'

import Logo from '../components/logo';

import '../css/mobile-nav.css';

const MobileNav = () => {

  const flatListToHierarchical = (
      data = [],
      {idKey='id',parentKey='parentId',childrenKey='children'} = {}
  ) => {
      const tree = [];
      const childrenOf = {};
      data.forEach((item) => {
          const newItem = {...item};
          const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
          childrenOf[id] = childrenOf[id] || [];
          newItem[childrenKey] = childrenOf[id];
          parentId
              ? (
                  childrenOf[parentId] = childrenOf[parentId] || []
              ).push(newItem)
              : tree.push(newItem);
      });
      return tree;
  };

  const data = useStaticQuery(graphql`
    {
      wpMenu(locations: {eq: MOBILE}) {
        count
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            id
            databaseId
            title
            url
            cssClasses
            description
            label
            linkRelationship
            target
            parentId
          }
        }
      }
    }
  `);

  let $hierarchicalList;
  if(data.wpMenu && data.wpMenu.menuItems && data.wpMenu.menuItems.nodes)
    $hierarchicalList = flatListToHierarchical( data.wpMenu.menuItems.nodes );

  let styles = {

    bmOverlay: {
      background: 'rgba(0, 0, 0, 0.3)',
    }
  }

  return (
    <React.Fragment>
      <Menu styles={styles} right className="mobilemenuwrapper" disableAutoFocus pageWrapId={ "page-wrap" } outerContainerId={ "outer-container" }>
        {$hierarchicalList &&
          $hierarchicalList.map(
            prop => {
              return (
              <div className="menu-item" key={prop.id}>
                <a href={prop.url}>
                  {prop.label}
                </a>
                {prop.children.length > 0 &&
                  <>
                    <button 
                      type="button" 
                      className="toggle-sub-menu" 
                      onClick={(e) => e.currentTarget.nextElementSibling.classList.toggle('open')}
                    >
                      <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>
                    </button>
                    <ul className="mobile-sub-menu">
                      {prop.children.map(child => {
                        return (
                          <li key={child.id} id={"nav-menu-item-"+prop.databaseId} className={child.children.length ? 'has-sub-menu' : ''}>
                            <a
                              href={child.url}
                              alt={child.label}
                            >
                              {child.label}
                            </a>

                            {child.children.length ? (
                              <>
                                <button 
                                  type="button" 
                                  className="toggle-sub-menu" 
                                  onClick={(e) => e.currentTarget.nextElementSibling.classList.toggle('open')}
                                >
                                  <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>
                                </button>
                                <ul className="mobile-sub-menu">
                                  {child.children.map(child => {
                                    return (
                                      <li key={child.id} id={"nav-menu-item-"+prop.databaseId}>
                                        <a
                                          href={child.url}
                                          alt={child.label}
                                        >
                                          {child.label}
                                        </a>
                                      </li>
                                    )
                                  })}
                                </ul>
                              </>
                            ) : ''}
                          </li>
                        )
                      })}
                      </ul>
                  </>
                }
              </div>
              )
            }
          )}
        <div className="mobile-utility-menu">
          <ul>
            <li><a href="/client-login/">Login</a></li>
            <li><a href="/systems-support">Systems Support</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
          </ul>
        </div>
      </Menu>
    </React.Fragment>
  )
}

export default MobileNav

